import React from "react";
import { Button } from "antd";

const getStatusProps = (status) => {
  switch (status) {
    case "init":
      return {
        text: "Scheduled",
        color: "var(--ion-color-green-600)",
        background: "var(--ion-color-green-100)",
      };
    case "success":
      return {
        text: "Triggered",
        color: "var(--ion-color-step-500)",
        background: "var(--ion-color-step-100)",
      };
    case "fail":
      return {
        text: "Fail",
        color: "var(--ion-color-red-600)",
        background: "var(--ion-color-red-100)",
      };
    default:
      return {
        text: "Unknown",
        color: "black",
        background: "white",
      };
  }
};


const Status = ({ status }) => {
  const { text, color, background } = getStatusProps(status);

  return (
    <Button
      type="text"
      style={{
        fontSize: "1rem",
        color: color,
        background: background,
      }}
    >
      {text}
    </Button>
  );
};

export default Status;
